import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import '../../assets/css/Covidalert.css';

export const CovidAlert = (CovidBanner) => {
    return(
        ReactHtmlParser(CovidBanner.content)
    )
}





// WEBPACK FOOTER //
// ./src/components/modules/CovidAlert.js